import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isNative:false,
  },
  mutations: {
    setIsNative(state, value) {
      state.isNative = value
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    getIsNative(state) {
      return state.isNative
    }
  },
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
      return { 
        newsActive: val.newsActive
      }
    }
  })]
})
